<template>
	<div class="raffle-container live">
		<div
			v-if="player && activePlayer && activePlayer.userCode != player"
			class="waiting-player"
		>
			Please Wait for your turn to play
		</div>
		<LiveStartGame :startGame="startGame"> </LiveStartGame>
		<LivePlayerActive
			:activePlayer="activePlayer"
			v-model:goToWinners="goToWinners"
			v-if="startGame"
			:isGameDisplay="!player"
		/>
		<LiveCarrousel
			v-model:animateReorder="animateReorder"
			:envelopes="envelopes"
			:activePlayer="activePlayer"
			:players="players"
			:updateActiveUser="updateActiveUser"
			:updateMoney="updateMoney"
			:money="money"
			v-model:page="page"
			:winnerInfo="winnerInfo"
			v-model:goToWinners="goToWinners"
			v-model:lastWinners="lastWinners"
			:startGame="startGame"
			:isGamePlayer="player"
			v-if="players.length != 0"
		/>
		<LiveWinner
			:players="players"
			v-model:goToWinners="goToWinners"
			:lastWinners="lastWinners"
			:isGameDisplay="!player"
			v-if="players.length != 0"
		/>
	</div>
</template>

<script>
	import LiveCarrousel from '@core/components/raffle/live/LiveCarrouselComponent.vue';
	import LivePlayerActive from '@core/components/raffle/live/LivePlayerActiveComponent.vue';
	import LiveStartGame from '@core/components/raffle/live/LiveStartGameComponent.vue';
	import LiveWinner from '@core/components/raffle/live/LiveWinnerComponent.vue';

	export default {
		name: 'LiveRaffle',
		emits: ['update:showStreamer', 'update:readyToVideo'],
		props: ['raffleInfo', 'player', 'readyToVideo', 'showStreamer'],
		data() {
			return {
				players: [],
				activePlayer: null,
				money: null,
				page: null,
				goToWinners: null,
				lastWinners: null,
				startGame: null,
				animateReorder: false,
				gameType: 'asd',
				envelopes: [],
				connected: false,
				adminConnected: false,
			};
		},
		computed: {},
		created() {
			this.init();
			this.$meetingHub.gameCashBashConnected();
		},
		beforeUnmount() {
			this.MeetingHubBus.off('cashBashReadyToStartAdmin', this.cashBashReadyToStartAdmin);
			this.MeetingHubBus.off('cashBashReadyToStartGame', this.cashBashReadyToStartGame);
			this.MeetingHubBus.off('cashBashReadySelectPlayer', this.cashBashReadySelectPlayer);
			this.MeetingHubBus.off('cashBashUpdateBashInfo', this.cashBashUpdateBashInfo);
			this.MeetingHubBus.off('cashBashGameConnected', this.cashBashGameConnected);
			this.MeetingHubBus.off('cashBashAdminCloseConnection', this.cashBashAdminCloseConnection);
		},
		methods: {
			init() {
				window.addEventListener('unload', this.handleClosePage);
				this.MeetingHubBus.on('cashBashReadyToStartAdmin', this.cashBashReadyToStartAdmin);
				this.MeetingHubBus.on('cashBashReadyToStartGame', this.cashBashReadyToStartGame);
				this.MeetingHubBus.on('cashBashReadySelectPlayer', this.cashBashReadySelectPlayer);
				this.MeetingHubBus.on('cashBashUpdateBashInfo', this.cashBashUpdateBashInfo);
				this.MeetingHubBus.on('cashBashGameConnected', this.cashBashGameConnected);
				this.MeetingHubBus.on('cashBashAdminCloseConnection', this.cashBashAdminCloseConnection);
			},
			handleClosePage() {
				this.$meetingHub.gameCashBashLeave(this.player);
			},
			cashBashAdminCloseConnection() {
				this.players = [];
				this.activePlayer = null;
				this.money = null;
				this.page = null;
				this.goToWinners = null;
				this.lastWinners = null;
				this.startGame = null;
				this.animateReorder = false;
				this.gameType = 'asd';
				this.envelopes = [];
				this.connected = false;
				this.adminConnected = false;
				this.$emit('update:showStreamer', false);
			},
			cashBashGameConnected() {
				this.connected = true;
			},
			cashBashUpdateBashInfo(BashInfoString) {
				let info = JSON.parse(BashInfoString);
				this.players = info.EmployeesContestInfo;
				this.envelopes = info.CardsContestInfo;
				this.$meetingHub.gameCashBashReadyToStart(this.player);
			},
			cashBashReadyToStartAdmin() {
				this.adminConnected = true;
				this.$meetingHub.gameAlreadyReady();
			},
			cashBashReadyToStartGame() {},
			cashBashReadySelectPlayer(playerId) {
				if (playerId) {
					this.startGame = true;
					this.$emit('update:showStreamer', true);
					this.activePlayer = this.players.find(p => p.id == playerId);
					this.activePlayer.updating = false;
					this.goToWinners = false;
					if (this.player) {
						if (this.activePlayer.userCode == this.player) {
							this.$emit('update:readyToVideo', true);
						} else {
							this.$emit('update:readyToVideo', false);
						}
					} else {
						this.$emit('update:readyToVideo', true);
					}
				} else {
					this.startGame = false;
					this.activePlayer = null;
					this.page = null;
					this.$emit('update:readyToVideo', false);
					this.$emit('update:showStreamer', false);
				}
			},
			sendPlayer(player) {
				this.activePlayer = player;
				this.activePlayer.updating = false;
				this.goToWinners = false;
			},

			updateActiveUser(value) {
				this.activePlayer = value;
			},
			updateMoney(value) {
				this.money = value;
			},
			winnerInfo(id) {
				return this.players.find(p => p.id == id);
			},
		},
		components: {
			LiveWinner,
			LiveCarrousel,
			LivePlayerActive,
			LiveStartGame,
		},
	};
</script>
<style>
	#freshworks-container {
		display: none !important;
	}

	.waiting-player {
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: #288090;
		z-index: 999999999;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 30px;
		color: white;
		text-align: center;
		padding: 0 35px;
	}
</style>
